<template>
    <div>
        <div class="card">
            <table class="table">
                <thead>
                <tr>
                    <th>No.</th>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Qty (Redeemed)</th>
                    <th>Total Price</th>
                </tr>
                </thead>

                <tbody>
                <tr v-if="loading">
                    <td colspan="5" class="text-center">
                        <b-spinner label="Spinning"></b-spinner>
                    </td>
                </tr>
                <tr v-for="(item, index) in items" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                        <div>{{ item.description }}</div>
                        <small class="text-muted">#{{ item.item_no }}</small>
                    </td>
                    <td>{{ item.unit_price }}</td>
                    <td>{{ item.sum_qty }}</td>
                    <td>{{ item.total | formatNumber }}</td>
                </tr>
                <tr v-if="! loading && items.length === 0">
                    <td colspan="5" class="text-center text-muted"><span>No results</span></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
    export default {

        props: {
            dateRanges: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            loading: false,
            items: [],
        }),

        watch: {
            dateRanges: {
                deep: true,
                handler({fromDate, toDate}) {
                    this.load({fromDate, toDate})
                }
            }
        },

        methods: {
            async load({fromDate, toDate}) {
                this.loading = true

                try {
                    const { data } = await axios.get(`/reports/low-prod`, {
                        params: {
                            from_date: fromDate,
                            to_date: toDate
                        }
                    })

                    this.items = data.data
                } catch (e) {
                    //
                }

                this.loading = false
            }
        },

        mounted() {
            this.load(this.$props.dateRanges)
        }
    }
</script>
